import { ActionBar } from "@/components/environments/ActionBar";
import type { FC } from "react";
import { SkeletonText } from "@/components/podkit/loading/Skeleton";
import { Heading1 } from "@/components/podkit/typography/Headings";
import { useEnvironment } from "@/queries/environment-queries";
import { useProject } from "@/queries/project-queries";
import { EnvironmentStatus_ContentPhase } from "gitpod-next-api/gitpod/v1/environment_pb";
import { Repository } from "@/components/environments/EnvironmentDetailsHeader";

export const EnvironmentDetailsContentHeader: FC<{ environmentId: string }> = ({ environmentId }) => {
    return (
        <div className="flex flex-col flex-wrap items-center justify-between gap-2 @xs:flex-row">
            <EnvironmentInformation environmentId={environmentId} />
            <ActionBar environmentId={environmentId} withOpenEditor={false} />
        </div>
    );
};

export const EnvironmentInformation: FC<{ environmentId: string }> = ({ environmentId }) => {
    const { data: environment, error: environmentError } = useEnvironment(environmentId);
    const { data: project } = useProject(environment?.metadata?.projectId);

    const isBasedOnProject = environment?.metadata?.projectId;
    const ready: boolean = (!!environment && !!project) || (!!environment && !environment?.metadata?.projectId);

    const gitFailed =
        Boolean(environmentError) || environment?.status?.content?.phase === EnvironmentStatus_ContentPhase.FAILED;

    return (
        <div className="flex min-w-0 shrink flex-col" translate="no">
            <SkeletonText ready={ready} className="w-52" size={"lg"}>
                <Heading1 className="flex flex-row truncate align-middle text-lg text-content-primary">
                    {isBasedOnProject ? (
                        <>{project?.metadata?.name}</>
                    ) : (
                        <Repository environment={environment} failed={gitFailed} showRepoUrlLink={true} />
                    )}
                </Heading1>
            </SkeletonText>
        </div>
    );
};
